import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
    StoreType,
    SilDeviceType,
    SilDeviceFilters,
    SortSilDevices,
    setSilModelDevicesProjectSubsystemIds,
    setSilModelDevicesProjectSubsystemSort,
    setSilModelDevicesProjectSubsystemFilters,
} from "client/store"
import {
    PageContent,
    Table,
    TableSearchWrapper,
    SortRows,
} from "client/components"

import SilDeviceSearch from "client/pages/search/silDeviceSearch"
import Columns from "./columns"

const ProjectSubsystems = () => {
    const deviceList = useSelector((state: StoreType) => state.silModelDevices.projectSubsystems.deviceList)
    const deviceIds = useSelector((state: StoreType) => state.silModelDevices.projectSubsystems.deviceIds)
    const sortColumn = useSelector((state: StoreType) => state.silModelDevices.projectSubsystems.sortColumn)
    const sortOrder = useSelector((state: StoreType) => state.silModelDevices.projectSubsystems.sortOrder)
    const filters = useSelector((state: StoreType) => state.silModelDevices.projectSubsystems.filters)

    const dispatch = useDispatch()

    useEffect(() => {
        const sortedIds = SortSilDevices(Object.values(deviceList), sortColumn, sortOrder, filters)
        dispatch(setSilModelDevicesProjectSubsystemIds(sortedIds))
    }, [deviceList, sortColumn, sortOrder, filters])

    const onSort: SortRows = (column: keyof SilDeviceType, order) => {
        dispatch(setSilModelDevicesProjectSubsystemSort(column, order))
    }

    const onFilter = (newFilters: SilDeviceFilters) => {
        dispatch(setSilModelDevicesProjectSubsystemFilters(newFilters))
    }

    const columns = Columns()

    return (
        <PageContent>
            <TableSearchWrapper>
                <SilDeviceSearch
                    id="projectSubsystems"
                    filters={filters}
                    onFilter={onFilter}
                />
            </TableSearchWrapper>
            <Table
                columns={columns}
                dataList={deviceList}
                dataIds={deviceIds}
                sortColumn={sortColumn}
                sortOrder={sortOrder}
                rowSize="md"
                showPagination
                onSort={onSort}
            />
        </PageContent>
    )
}
export default ProjectSubsystems
